// Re-export unified chart types from canonical source
export type { ChartTypeValue } from "@/lib/lytick/chart-config"
export { CHART_TYPES } from "@/lib/lytick/chart-config"

// Re-export unified indicator types from canonical source
export type { IndicatorCategory } from "@/lib/lytick/chart-config"
export { INDICATOR_CATALOG } from "@/lib/lytick/indicatorRegistry"
export type { IndicatorCatalogEntry } from "@/lib/lytick/indicatorRegistry"

// Re-export unified drawing tool types from canonical source
export type { DrawingToolId, DrawingToolDefinition, DrawingToolGroup } from "@/lib/lytick/drawingToolDefinitions"
export { DRAWING_TOOLS, TOOL_LABELS } from "@/lib/lytick/drawingToolDefinitions"

export const DRAWING_COLORS = [
  "#E4EAF4",  // default text
  "#F04545",  // bearish
  "#16B85A",  // bullish
  "#5DC8E8",  // measure/cyan
  "#0EC4B4",  // info/teal
  "#F07848",  // alert/orange
  "#9D7FEA",  // pattern/violet
  "#EC4899",  // pink
  "#F5A623",  // fib/amber
  "#8FA8C8",  // secondary text
];
